import { connect } from "react-redux";
import { StreakCounter as Component } from "@learningblocks/storybook-components";
import { getCurrentStreak, getLongestStreak } from "./StreakCounter.selector";

function mapStateToProps(state) {
  return {
    currentStreak: getCurrentStreak(state),
    longestStreak: getLongestStreak(state),
    isLatestOperationCorrect: !(getCurrentStreak(state) === 0),
  };
}

function mapDispatchToProps() {
  return {};
}

export const StreakCounter = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
